import { Chip, type ChipProps } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/dateTime/dateRangeFilterChip.module.css";

interface DateRangeFilterChipProps {
  filterLabel: string;
  startDate?: Date | null;
  endDate?: Date | null;
  onDelete?: ChipProps["onDelete"];
  onClick?: ChipProps["onClick"];
  onNavigateLeft?: () => void;
  onNavigateRight?: () => void;
}

const DateRangeFilterChip = ({
  filterLabel,
  startDate,
  endDate,
  onDelete,
  onClick,
  onNavigateLeft,
  onNavigateRight,
}: DateRangeFilterChipProps) => {
  const { t } = useTranslation();
  let dateLabel = "";

  if (startDate && !endDate) {
    dateLabel = `${t("date_from")} ${dayjs(startDate).format("DD.MM.YYYY")}`;
  } else if (startDate && endDate && dayjs(startDate).isSame(endDate, "day")) {
    dateLabel = dayjs(startDate).format("DD.MM.YYYY");
  } else if (startDate && endDate) {
    dateLabel = `${dayjs(startDate).format("DD.MM.YYYY")} - ${dayjs(
      endDate,
    ).format("DD.MM.YYYY")}`;
  }

  return (
    <div className={styles.container}>
      {onNavigateLeft && (
        <GenericButton
          variant="icon"
          color="iconBase"
          onClick={onNavigateLeft}
        >
          <ChevronLeftIcon />
        </GenericButton>
      )}
      <Chip
        size="medium"
        label={`${filterLabel}: ${dateLabel}`}
        className={styles.chip}
        classes={{ deleteIcon: styles.deleteIcon }}
        onDelete={onDelete}
        onClick={onClick}
        clickable={Boolean(onClick)}
      />
      {onNavigateRight && (
        <GenericButton
          variant="icon"
          color="iconBase"
          onClick={onNavigateRight}
        >
          <ChevronRightIcon />
        </GenericButton>
      )}
    </div>
  );
};

export default DateRangeFilterChip;
